import _ from 'underscore';
import { Decorator } from './decorator';

export class DateFilterDecorator extends Decorator {
  /**
   * Creates an instance of DateFilterDecorator.
   * @param {Object} {
   *  isOdataActionSource = false,
   *  deps: The legacy dependencies of the component
   *  deps.state: 'component/state/index' component
   *  deps.dateUtil: 'component/humanize/date' component
   * }
   * @memberof DateFilterDecorator
   */
  constructor({ isOdataActionSource = false, deps }) {
    super({ name: 'dateFilter', deps, expectedDeps: ['state', 'dateUtil'] });

    this.state = deps.state;
    this.dateUtil = deps.dateUtil;

    this.isOdataActionSource = isOdataActionSource;
    this.currentRange = null;
  }

  getValueAsync() {
    return this.state.getPromise('$daterange');
  }

  formatDateInQuery(date) {
    return this.dateUtil.format(date, 'M/d/yyyy');
  }

  formatDateInEntitySet(date) {
    return this.dateUtil.format(date, 'yyyy-MM-dd');
  }

  buildQuery(queryParams, dateRange) {
    this.currentRange = { startDate: dateRange.start, endDate: dateRange.end };
    if (dateRange.compared) {
      _.extend(this.currentRange, {
        comparisonStartDate: dateRange.compared.start,
        comparisonEndDate: dateRange.compared.end,
      });
    }
    let transformedQueryParams = this.addDateRangeToQueryParams(queryParams);
    if (this.isOdataActionSource) {
      transformedQueryParams = this.changeEntitySet(transformedQueryParams);
    }
    return transformedQueryParams;
  }

  addDateRangeToQueryParams(queryParams) {
    const {
      startDate,
      endDate,
      comparisonStartDate,
      comparisonEndDate,
    } = this.currentRange;
    let query = _.defaults(
      {
        startDate: this.formatDateInQuery(startDate),
        endDate: this.formatDateInQuery(endDate),
      },
      queryParams.query
    );

    if (comparisonStartDate && comparisonEndDate) {
      query = _.defaults(
        {
          comparisonStartDate: this.formatDateInQuery(comparisonStartDate),
          comparisonEndDate: this.formatDateInQuery(comparisonEndDate),
        },
        query
      );
    } else {
      query = _.omit(query, 'comparisonStartDate', 'comparisonEndDate');
    }
    return _.defaults(
      {
        query,
      },
      queryParams
    );
  }

  changeEntitySet(queryParams) {
    const {
      startDate,
      endDate,
      comparisonStartDate,
      comparisonEndDate,
    } = this.currentRange;

    // eslint-disable-next-line no-param-reassign
    queryParams.gridDataParameters = _.omit(_.defaults(
      {
        DateRange: {
          StartDate: this.formatDateInEntitySet(startDate),
          EndDate: this.formatDateInEntitySet(endDate),
        },
        ComparisonDateRange: comparisonStartDate && comparisonEndDate
          ? {
            StartDate: this.formatDateInEntitySet(comparisonStartDate),
            EndDate: this.formatDateInEntitySet(comparisonEndDate),
          }
          : undefined,
      },
      queryParams.gridDataParameters
    ), _.isUndefined);

    return queryParams;
  }
}
